(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nlt-cart-reference"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nlt-cart-reference')) {
  let pendingCart;
  const attribute = 'Referencia de carrito NLT';
  const root = () => window.Shopify?.routes?.root || '/';
  const loadCart = () => {
    if (!pendingCart) {
      pendingCart = (async () => {
        const response = await fetch(root() + 'cart.js', {cache:'no-store', credentials:'same-origin'});
        if (!response.ok) throw new Error('cart');
        let cart = await response.json();
        if (!cart.item_count) return {cart, reference:null};
        let reference = cart.attributes?.[attribute];
        if (!/^NLT-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{4}$/.test(reference || '')) {
          if (!cart.token) throw new Error('cart');
          const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(cart.token.split('?')[0]));
          const code = Array.from(new Uint8Array(digest)).slice(0,6).map(n => n.toString(16).padStart(2,'0')).join('').toUpperCase();
          reference = 'NLT-' + code.match(/.{4}/g).join('-');
          const saved = await fetch(root() + 'cart/update.js', {
            method:'POST', credentials:'same-origin',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({attributes:{[attribute]:reference}})
          });
          if (!saved.ok) throw new Error('save');
          cart = await saved.json();
        }
        return {cart, reference};
      })().finally(() => { pendingCart = null; });
    }
    return pendingCart;
  };
  class NltCartReference extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelector('[data-copy]').addEventListener('click', async () => {
        if (!this.reference) return;
        try {
          await navigator.clipboard.writeText(this.reference);
          this.querySelector('[data-status]').textContent = this.dataset.copied;
        } catch {
          this.querySelector('[data-status]').textContent = this.dataset.copyError;
        }
      }, {signal:this.abort.signal});
      this.querySelector('[data-share]').addEventListener('click', async event => {
        event.preventDefault();
        try {
          const result = await loadCart();
          this.render(result);
          if (result.cart.item_count) window.location.assign(this.querySelector('[data-share]').href);
        } catch {
          this.querySelector('[data-status]').textContent = this.dataset.error;
        }
      }, {signal:this.abort.signal});
      this.refresh = () => loadCart().then(result => {
        if (this.isConnected) this.render(result);
      }).catch(() => {
        if (!this.reference) this.hidden = true;
        else this.querySelector('[data-status]').textContent = this.dataset.error;
      });
      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        for (const topic of [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.cartOpen]) {
          if (topic) this.unsubscribers.push(subscribe(topic, this.refresh));
        }
      }
      window.addEventListener('pageshow', this.refresh, {signal:this.abort.signal});
      this.refresh();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.unsubscribers?.forEach(unsubscribe => unsubscribe());
    }
    render({cart, reference}) {
      this.hidden = !cart.item_count;
      this.reference = reference;
      if (this.hidden) return;
      this.querySelector('[data-reference]').textContent = reference;
      this.querySelector('[data-status]').textContent = '';
      const money = new Intl.NumberFormat('es-MX', {style:'currency', currency:cart.currency, currencyDisplay:'code'});
      const lines = cart.items.map(item => {
        const sku = item.sku ? ' · SKU: ' + item.sku : '';
        return item.quantity + ' × ' + item.title + sku + ' · ' + money.format(item.final_line_price / 100);
      });
      const message = [this.dataset.intro, this.dataset.label + ' ' + reference, '', ...lines, '', this.dataset.total + ' ' + money.format(cart.total_price / 100)].join('\n');
      this.querySelector('[data-share]').href = 'https://wa.me/526251111643?text=' + encodeURIComponent(message);
    }
  }
  customElements.define('nlt-cart-reference', NltCartReference);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-catalog-controls"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-catalog-controls'))customElements.define('nlt-catalog-controls',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.catalog=this.closest('nlt-context-catalog,nlt-oil-catalog,nlt-manijauto-extra');
    this.form=this.catalog?.querySelector('.nlt-oil-filters,.nlt-manijauto-extra-form');
    this.sort=this.catalog?.querySelector('[data-sort-control]')||this.catalog?.closest('.facets-vertical')?.querySelector('.nlt-manijauto-sort-form [data-sort-control]');
    this.dialog=this.querySelector('dialog');this.toggle=this.querySelector('.nlt-catalog-filter-toggle');
    if(!this.form||!this.sort||typeof this.dialog.showModal!=='function')return;
    this.ready=true;
    this.formPlace=document.createComment('');this.sortPlace=document.createComment('');
    this.form.before(this.formPlace);this.sort.before(this.sortPlace);
    this.toggle.addEventListener('click',()=>this.open());
    this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
    this.querySelector('[data-apply]').addEventListener('click',()=>{if(this.catalog.matches('nlt-manijauto-extra')&&!this.form.reportValidity())return;this.dialog.close();});
    this.dialog.addEventListener('close',()=>this.restore());
    this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();});
    this.media=matchMedia('(max-width:749px)');
    this.onResize=()=>{if(!this.media.matches&&this.dialog.open)this.dialog.close();};
    this.media.addEventListener('change',this.onResize);
    this.dataset.ready='true';
  }
  open(){
    if(!this.media.matches||this.dialog.open)return;
    this.querySelector('.nlt-catalog-filter-body').append(this.form,this.sort);
    this.dialog.showModal();this.toggle.setAttribute('aria-expanded','true');
  }
  restore(){
    this.formPlace.after(this.form);this.sortPlace.after(this.sort);
    this.toggle.setAttribute('aria-expanded','false');
  }
  disconnectedCallback(){this.media?.removeEventListener('change',this.onResize);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-category-panel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-parts-menu'))customElements.define('nlt-parts-menu',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const tabs=[...this.querySelectorAll('[data-parts-tab]')],panels=[...this.querySelectorAll('[data-parts-panel]')];
const select=tab=>{tabs.forEach(t=>t.setAttribute('aria-pressed',String(t===tab)));panels.forEach(p=>p.hidden=p.dataset.partsPanel!==tab.dataset.partsTab);};
tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();const next=tabs[(i+(e.key==='ArrowDown'?1:-1)+tabs.length)%tabs.length];next.focus();select(next);}});});
if(tabs.length)select(tabs[0]);
this.querySelector('.nlt-category-close')?.addEventListener('click',()=>{const details=this.closest('details');if(!details)return;const menu=details.closest('header-menu');if(typeof menu?.close==='function')menu.close();details.open=false;const summary=details.querySelector('summary');summary?.setAttribute('aria-expanded','false');summary?.focus();});
}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-context-catalog"] && !Shopify.designMode) return;
  try {
    function nltContextClassifyOil(title, t) {
  const s=title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const usage=[];
  if (/^(kit|paquete)\b/.test(s)) usage.push(t.other);
  else if (/^(aditivo|limpiador|liquido lavado)|flush|limpiador/.test(s)) usage.push(t.additives);
  else if (/anticongelante|refrigerante|coolant/.test(s)) usage.push(t.coolant);
  else if (/^filtro/.test(s)) usage.push(t.filters);
  else if (/^grasa/.test(s)) usage.push(t.grease);
  else {
    if (/transmision|transmission|\batf\b|synchromesh|powershift|supershift/.test(s)) usage.push(t.transmission);
    if (/diferencial|differencial|differential|engran|severe gear|gear lube/.test(s)) usage.push(t.differential);
    if (/aceite.*motor|motor.*aceite|\b2t\b|\b4t\b/.test(s)) usage.push(t.motor);
    if (/suspension|shock/.test(s)) usage.push(t.suspension);
  }
  if (!usage.length) usage.push(t.other);
  const lines=[[/sign[ai]ture series/,'Signature Series'],[/\boe\b/,'OE'],[/\bxl\b/,'XL'],[/dominator/,'Dominator'],[/severe gear/,'Severe Gear'],[/heavy[ -]?duty/,'Heavy-Duty'],[/premium protection/,'Premium Protection'],[/z[ -]?rod/,'Z-ROD'],[/interceptor/,'Interceptor'],[/saber/,'SABER'],[/v[ -]?twin/,'V-Twin'],[/metric motorcycle/,'Metric Motorcycle'],[/dirt bike/,'Dirt Bike'],[/atv\/utv/,'ATV/UTV'],[/synchromesh/,'Synchromesh'],[/powershift/,'Powershift'],[/super[ -]?shift/,'Super Shift'],[/grado comercial/,'Commercial Grade']];
  const line=(lines.find(([re])=>re.test(s))||[null,t.other])[1];
  const multi=[...s.matchAll(/\b(\d{1,3})\s*w\s*[-– ]?\s*(8|12|16|20|30|40|50|60|70|75|80|85|90|110|140|190|250)\b/g)].map(m=>`${Number(m[1])}W-${m[2]}`);
  const mono=s.match(/\bsae\s*(\d{2,3})\b/);
  const viscosity=multi.length?[...new Set(multi)]:[mono?`SAE ${mono[1]}`:t.unspecified];
  const measure=s.match(/\b(\d+(?:[.,]\d+)?)\s*(ml|litros?|l|kg|g)\b/);
  let size=t.unspecified;
  if (/^(kit|paquete)\b/.test(s)) size=t.kit;
  else if(measure){const raw=Number(measure[1].replace(',','.')),unit=measure[2],n=/^(l|litro|litros)$/.test(unit)&&raw===10?9.46:raw;size=/^(ml|l|litro|litros)$/.test(unit)&&[3.78,3.785].includes(n)?t.gallon:unit==='ml'&&n===946?t.quart:/^(l|litro|litros)$/.test(unit)&&n===1?t.liter:`${n} ${unit.startsWith('l')?'L':unit}`;}
  else if(/\bgal[oó]n\b/.test(s)) size=t.gallon;
  return {usage,line:[line],viscosity,size:[size]};
}
function nltContextTitleFitment(title) {
  const make=title.match(/\b(Acura|Audi|BMW|Buick|Cadillac|Chevrolet|Chevy|Chrysler|Dodge|Fiat|Ford|GMC|Honda|Hyundai|Infiniti|Isuzu|Jeep|Kia|Land Rover|Lexus|Lincoln|Mazda|Mercedes(?:[- ]Benz)?|Mercury|Mini|Mitsubishi|Nissan|Oldsmobile|Peugeot|Pontiac|Porsche|Ram|Renault|Saab|Saturn|Scion|Seat|Skoda|Subaru|Suzuki|Toyota|Volkswagen|Volvo|VW)\b/i);
  if(!make)return {make:[],model:[],year:[]};
  const tail=title.slice(make.index+make[0].length);
  const years=tail.match(/\b((?:19|20)\d{2})(?:\s*[-–/]\s*((?:19|20)\d{2}))?\b/);
  if(!years)return {make:[],model:[],year:[]};
  const first=Number(years[1]),last=Number(years[2]||years[1]);
  if(last<first||last-first>60)return {make:[],model:[],year:[]};
  const model=tail.slice(0,years.index).trim().replace(/\s+/g,' ');
  if(!model||model.length>60||/[,/]|\by\b/i.test(model))return {make:[],model:[],year:[]};
  const aliases={chevy:'Chevrolet',vw:'Volkswagen'};
  const name=aliases[make[0].toLowerCase()]||make[0];
  return {make:[name],model:[model.toUpperCase()],year:Array.from({length:last-first+1},(_,i)=>String(first+i))};
}

function nltContextClassify(product,t){
  const s=product.title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const groups=[[/\b(llave|control remoto|carcasa|cascara|transponder|chip|lishi)\b/,'keys'],[/\bfiltro\b/,'filter'],[/\b(balata|freno|disco de freno|tambor de freno)\b/,'brakes'],[/\b(amortiguador|muelle|rotula|bolsa de aire|baleros?)\b/,'suspension'],[/\b(aceite|lubricante|atf|anticongelante|refrigerante|aditivo|grasa|limpiador|fluido)\b/,'fluids'],[/\b(bateria|acumulador)\b/,'battery'],[/\b(faro|foco|lampara|calavera|led)\b/,'lighting'],[/\b(alternador|marcha|sensor|relevador|bobina|bujia)\b/,'electric'],[/\b(espejo|manija|chapa|salpicadera|cofre|defensa)\b/,'body'],[/\b(cera|pulidor|polish|shampoo|sellador|microfibra)\b/,'care']];
  const isCare=/\b(adam['’]?s|koch[ -]?chemie|meguiar['’]?s|shampoo|champu|polish|polishes|graphene|grafeno|carnauba|detailing|microfibra|microfiber|ceramic coating|car wash|tire shine)\b/.test(s);
  const family=isCare?'care':(groups.find(([re])=>re.test(s))||[null,'generic'])[1];
  const result={care_type:[],care_technology:[],care_surface:[],category:[t[family]||t.generic],usage:[],line:[],viscosity:[],size:[],brand:[],make:[],model:[],year:[],frequency:[],buttons:[],chip:[],position:[],material:[],voltage:[],capacity:[]};
  if(family==='fluids'){
    const oil=nltContextClassifyOil(product.title,t);
    for(const k of ['usage','line','viscosity','size'])result[k]=oil[k].filter(v=>v&&v!==t.other&&v!==t.unspecified);
  }
  if(family==='care'){
    const name=s.replace(/\badam['’]?s\s*(?:polishes)?/g,'').trim();
    const accessory=!/cleaner|limpiador|revitalizer|detergente/.test(name)&&/\b(pad|pads|toalla|towel|microfibra|microfiber|brush|cepillo|aplicador|applicator|applcator|backing plate|pulidora|polisher|swirl killer|pistola|foam cannon|bucket|cubeta|guante|mitt)\b/.test(name);
    const rules=accessory?[[/\b(pad|pads|backing plate)\b/,'care_pads'],[/microfibra|microfiber|toalla|towel/,'care_towels'],[/brush|cepillo/,'care_brushes'],[/aplicador|applicator|applcator/,'care_applicators'],[/pulidora|polisher|swirl killer/,'care_machines']]:[
      [/shampoo|champu|car wash|mega foam|snow foam/,'care_shampoo'],
      [/compound|compuesto|scratch.*remover|swirl.*remover/,'care_compound'],
      [/\bpolish\b|pulidor|pulimento/,'care_polish'],
      [/\bwax\b|\bcera\b|carnauba/,'care_wax'],
      [/sealant|sellador/,'care_sealant'],
      [/coating|recubrimiento/,'care_coating'],
      [/detail spray|detailer|quick detail|waterless|rinseless/,'care_detailer'],
      [/tire shine|dressing|abrillantador|vrt|trim restorer|in & out/,'care_dressing'],
      [/cleaner|limpiador|degreaser|desengrasante|remover|revitalizer/,'care_cleaner'],
      [/air freshener|aromat|odor|odour/,'care_fragrance']];
    for(const [re,key]of rules)if(re.test(name))result.care_type.push(t[key]);
    if(accessory&&!result.care_type.length)result.care_type=[t.care_accessories];
    if(!accessory){
      for(const [re,key]of [[/graphene|grafeno/,'care_graphene'],[/ceramic|ceramico|sio2/,'care_ceramic'],[/carnauba/,'care_carnauba']])if(re.test(name))result.care_technology.push(t[key]);
      result.size=nltContextClassifyOil(product.title,t).size.filter(v=>v&&v!==t.unspecified);
    }
    for(const [re,key]of [[/wheel|tire|rin|rines|llanta|neumatico/,'care_wheels'],[/glass|vidrio|cristal/,'care_glass'],[/leather|cuero|piel/,'care_leather'],[/interior|carpet|tapiceria|textil/,'care_interior'],[/metal|chrome|cromo|aluminio/,'care_metal'],[/paint|pintura|car wash|shampoo|mega foam/,'care_paint']])if(re.test(name))result.care_surface.push(t[key]);
  }
  if(family==='filter'){
    for(const [re,key]of [[/aceite/,'oil_filter'],[/combustible|diesel|gasolina/,'fuel_filter'],[/aire/,'air_filter'],[/cabina|cabine|polen/,'cabin_filter'],[/hidraulico/,'hydraulic_filter'],[/transmision/,'transmission']])if(re.test(s))result.usage.push(t[key]);
    if(result.usage.includes(t.cabin_filter))result.usage=result.usage.filter(v=>v!==t.air_filter);
  }
  if(family==='keys'){
    if(/carcasa|cascara/.test(s))result.usage=[t.key_shell];
    else if(/proximidad|presencia|smart/.test(s))result.usage=[t.smart_key];
    else if(/transponder|chip/.test(s))result.usage=[t.chip];
    else if(/control/.test(s))result.usage=[t.remote];
  }
  if(product.vendor&&!/^(woocommerce|ninguno|nlt keys)$/i.test(product.vendor))result.brand=[product.vendor];
  const values=x=>(Array.isArray(x)?x:[x]).filter(v=>typeof v==='string'||typeof v==='number').map(String).filter(Boolean);
  for(const [key,source]of Object.entries({make:'marca',model:'modelo',year:'ano',frequency:'frecuencia',buttons:'botones',chip:'chip'}))result[key]=values(product.meta?.[source]);
  const fitment=nltContextTitleFitment(product.title);
  for(const key of ['make','model','year'])if(!result[key].length)result[key]=fitment[key];
  if(family==='keys'){
    if(!result.frequency.length){const m=s.match(/\b(\d{3}(?:[.,]\d+)?)\s*mhz\b/);if(m)result.frequency=[m[1].replace(',','.')+' MHz'];}
    if(!result.buttons.length){const m=s.match(/\b([1-9])\s*botones?\b/);if(m)result.buttons=[m[1]];}
  }
  if(['brakes','suspension','body','lighting'].includes(family)){
    for(const [re,key]of [[/\bdelanter[oa]s?\b/,'front'],[/\btraser[oa]s?\b/,'rear'],[/\bizquierd[oa]s?\b/,'left'],[/\bderech[oa]s?\b/,'right']])if(re.test(s))result.position.push(t[key]);
  }
  if(family==='brakes'){
    if(/ceramic/.test(s))result.material.push(t.ceramic);
    else if(/semi[ -]?metalic/.test(s))result.material.push(t.semi_metallic);
  }
  if(['battery','electric','lighting'].includes(family)){const m=s.match(/\b(6|12|24|48)\s*v\b/);if(m)result.voltage=[m[1]+' V'];}
  if(family==='battery'){const cca=s.match(/\b(\d{2,4})\s*cca\b/),ah=s.match(/\b(\d{1,3})\s*ah\b/);if(cca)result.capacity.push(cca[1]+' CCA');if(ah)result.capacity.push(ah[1]+' Ah');}
  return result;
}

if(!customElements.get('nlt-context-catalog')) customElements.define('nlt-context-catalog',class extends HTMLElement{
  async connectedCallback(){
    if(this.started)return;this.started=true;
    this.t={...JSON.parse(this.querySelector('[data-text]').textContent),...JSON.parse(this.querySelector('[data-context-text]').textContent)};
    this.keys=['category','care_type','care_technology','care_surface','usage','line','viscosity','size','brand','make','model','year','frequency','buttons','chip','position','material','voltage','capacity','availability'];
    this.nativeMap={availability:'filter.v.availability',brand:'filter.p.vendor',make:'filter.p.m.custom.marca',model:'filter.p.m.custom.modelo',year:'filter.p.m.custom.ano',frequency:'filter.p.m.custom.frecuencia',buttons:'filter.p.m.custom.botones',chip:'filter.p.m.custom.chip',min:'filter.v.price.gte',max:'filter.v.price.lte'};
    this.native=this.closest('.shopify-section').querySelector('.nlt-collection,.nlt-search');
    if([...new URL(location.href).searchParams.keys()].some(k=>k.startsWith('filter.')&&k!=='filter.p.product_type'&&!Object.values(this.nativeMap).includes(k))){this.hidden=true;return;}
    if(Number(this.dataset.countTotal)>(this.dataset.search==='true'?999:25000)){this.hidden=true;return;}
    this.form=this.querySelector('form');this.sort=this.querySelector('[data-sort]');this.limit=24;
    this.money=new Intl.NumberFormat(this.dataset.locale||'es-MX',{style:'currency',currency:this.dataset.currency||'MXN'});
    this.loadingNotice=this.querySelector('[data-status]').cloneNode(true);
    this.native?.before(this.loadingNotice);
    try{
      const fetchPage=async page=>{
        const u=new URL(location.href);for(const key of [...u.searchParams.keys()])if(key.startsWith('oil_')||(key.startsWith('filter.')&&key!=='filter.p.product_type'))u.searchParams.delete(key);u.searchParams.set('view','nlt-context-data');if(this.dataset.search==='true')u.searchParams.set('type','product');u.searchParams.set('page',page);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);
        for(let attempt=0;attempt<2;attempt++){
          try{
            const r=await fetch(u,{credentials:'same-origin',signal:AbortSignal.timeout(20000)});
            if(!r.ok)throw Error('catalog');
            const data=await r.json();if(!Array.isArray(data.products))throw Error('catalog');
            return data;
          }catch(error){if(attempt===1)throw error;}
        }
      };
      const first=await fetchPage(1);if(!Array.isArray(first.products))throw Error('catalog');
      if(first.total>(this.dataset.search==='true'?999:25000))throw Error('catalog');
      const products=[...first.products];
      this.loadingNotice.textContent=this.t.loading||this.querySelector('[data-status]').textContent;
      for(let page=2;page<=first.pages;page+=4){const batch=await Promise.all(Array.from({length:Math.min(4,first.pages-page+1)},(_,i)=>fetchPage(page+i)));for(const data of batch)products.push(...data.products);this.loadingNotice.textContent=this.querySelector('[data-status]').textContent+' '+products.length+' / '+first.total;}
      if(new Set(products.map(p=>p.id)).size!==first.total)throw Error('catalog');
      this.products=[...new Map(products.map(p=>[p.id,p])).values()].map(p=>({...p,...nltContextClassify(p,this.t),availability:[p.available?'1':'0']}));
      for(const name of this.keys){
        const container=this.form.querySelector(`[data-options="${name}"]`);
        const values=[...new Set(this.products.flatMap(p=>p[name]||[]))].sort((a,b)=>a.localeCompare(b,'es',{numeric:true}));
        if(!values.length||(name==='category'&&values.length===1)){container.closest('details').hidden=true;continue;}
        for(const value of values){
          const label=document.createElement('label');label.className='nlt-oil-checkbox';
          const input=document.createElement('input');input.type='checkbox';input.name=name;input.value=value;
          const text=document.createElement('span');text.textContent=name==='availability'?(value==='1'?this.t.available:this.t.sold_out):value;
          label.append(input,text);container.append(label);
        }
      }
      this.readURL();
      this.form.addEventListener('submit',e=>e.preventDefault());
      this.form.addEventListener('change',()=>{this.limit=24;this.render(true).catch(()=>{});});
      this.form.addEventListener('reset',()=>setTimeout(()=>{this.sort.value='featured';this.limit=24;this.render(true).catch(()=>{});},0));
      this.sort.addEventListener('change',()=>{this.limit=24;this.render(true).catch(()=>{});});
      this.querySelector('[data-more]').addEventListener('click',()=>{this.limit+=24;this.render(false).catch(()=>{});});
      this.onPop=()=>{this.readURL();this.limit=24;this.render(false).catch(()=>{});};window.addEventListener('popstate',this.onPop);
      await this.render(false);
      if(this.dataset.search==='true'&&this.native?.querySelector('.nlt-search-heading h1'))this.querySelector('h1').textContent=this.native.querySelector('.nlt-search-heading h1').textContent;
      if(this.native)this.native.remove();
      this.hidden=false;
      this.querySelector('[data-status]').hidden=true;this.querySelector('[data-interface]').hidden=false;
      this.loadingNotice.remove();
    }catch(error){this.hidden=true;if(this.loadingNotice)this.loadingNotice.textContent=this.t.error;}
  }
  disconnectedCallback(){window.removeEventListener('popstate',this.onPop);}
  readURL(){
    const p=new URL(location.href).searchParams;
    for(const field of this.form.elements){
      if(!field.name)continue;
      if(field.type==='checkbox'){
        const values=p.getAll('oil_'+field.name).map(value=>{
          if(field.name!=='size')return value;
          if(/^3[.,]78(?:5)?\s*(?:ml|l)$/i.test(value.trim())||value==='Galón (3.785 L)')return this.t.gallon;
          if(value==='Cuarto (946 ml)')return this.t.quart;
          if(value==='Litro (1 L)')return this.t.liter;
          if(/^10\s*l$/i.test(value.trim()))return '9.46 L';
          return value;
        });
        if(!values.length&&this.nativeMap[field.name])values.push(...p.getAll(this.nativeMap[field.name]));
        field.checked=values.includes(field.value);
        if(field.checked)field.closest('details').open=true;
      }else field.value=p.get('oil_'+field.name)||(field.name==='min'?p.get('filter.v.price.gte'):field.name==='max'?p.get('filter.v.price.lte'):'')||'';
    }
    this.sort.value=p.get('oil_sort')||'featured';
  }
  async render(updateURL){
    const renderId=this.renderId=(this.renderId||0)+1;
    const data=new FormData(this.form),keys=this.keys;
    const state=Object.fromEntries(keys.map(k=>[k,data.getAll(k)]));
    state.min=data.get('min')||'';state.max=data.get('max')||'';
    for(const k of keys){this.querySelector(`[data-selection-count="${k}"]`).textContent=state[k].length?` (${state[k].length})`:'';}
    if(updateURL){
      const u=new URL(location.href);
      for(const[k,v]of Object.entries(state)){u.searchParams.delete('oil_'+k);for(const value of Array.isArray(v)?v:[v])if(value!=='')u.searchParams.append('oil_'+k,value);}
      this.sort.value==='featured'?u.searchParams.delete('oil_sort'):u.searchParams.set('oil_sort',this.sort.value);
      u.searchParams.delete('page');for(const key of [...u.searchParams.keys()])if(key.startsWith('filter.')&&key!=='filter.p.product_type')u.searchParams.delete(key);history.pushState({},'',u);
    }
    let selected=this.products.filter(p=>keys.every(k=>!state[k].length||state[k].some(v=>(p[k]||[]).includes(v)))&&(state.min===''||p.price>=Number(state.min)*100)&&(state.max===''||p.price<=Number(state.max)*100));
    if(this.sort.value==='price_up')selected.sort((a,b)=>a.price-b.price);if(this.sort.value==='price_down')selected.sort((a,b)=>b.price-a.price);if(this.sort.value==='az')selected.sort((a,b)=>a.title.localeCompare(b.title));
    this.querySelector('[data-count]').textContent=`${selected.length} ${this.t.results}`;
    const chips=this.querySelector('[data-chips]');chips.replaceChildren();
    for(const[k,values]of Object.entries(state)){
      for(const v of Array.isArray(values)?values:[values]){
        if(v==='')continue;
        const b=document.createElement('button');b.type='button';
        let label=k==='availability'?(v==='1'?this.t.available:this.t.sold_out):v;
        if(k==='min'||k==='max')label=`${k==='min'?this.t.from:this.t.to}: ${this.money.format(Number(v))}`;
        else label=`${this.t[k]}: ${label}`;
        b.textContent=label+' ×';
        b.addEventListener('click',()=>{
          for(const field of this.form.elements){if(field.name!==k)continue;if(field.type==='checkbox'){if(field.value===v)field.checked=false;}else field.value='';}
          this.limit=24;this.render(true).catch(()=>{});
        });chips.append(b);
      }
    }
    const grid=this.querySelector('[data-products]');grid.setAttribute('aria-busy','true');
    const visible=selected.slice(0,this.limit);
    try{
      for(let start=0;start<visible.length;start+=6){
        await Promise.all(visible.slice(start,start+6).map(async product=>{
          if(product.card)return;
          const url=new URL(product.url,location.origin);url.searchParams.set('view','nlt-context-card');
          const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
          const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw Error('card');
          const data=await response.json();if(!data.card)throw Error('card');product.card=data.card;
        }));
        if(renderId!==this.renderId)return;
      }
      grid.replaceChildren();
      for(const p of visible){
        const card=document.createElement('div');card.className='nlt-oil-native-card';
        card.innerHTML=p.card.replaceAll('<quick-add-bulk','<nlt-context-quick-add-bulk').replaceAll('</quick-add-bulk>','</nlt-context-quick-add-bulk>');
        for(const control of card.querySelectorAll('nlt-context-quick-add-bulk'))control.id=`nlt-context-quantity-${p.id}`;
        grid.append(card);
      }
      grid.removeAttribute('aria-busy');
    }catch(error){
      if(renderId!==this.renderId)return;
      this.hidden=true;
      this.querySelector('[data-interface]').hidden=true;if(this.native&&!this.native.isConnected){this.native=this.native.cloneNode(true);this.after(this.native);}throw error;
    }
    this.querySelector('[data-empty]').hidden=selected.length>0;this.querySelector('[data-more]').hidden=selected.length<=this.limit;
  }
});

customElements.whenDefined('quick-add-bulk').then(()=>{
  if(customElements.get('nlt-context-quick-add-bulk'))return;
  customElements.define('nlt-context-quick-add-bulk',class extends customElements.get('quick-add-bulk'){
    sendRequest(queue,element){this.requestStarted=true;const items={};for(const item of queue)items[item.id]=item.quantity;this.queue=this.queue.filter(item=>!queue.includes(item));this.updateMultipleQty(items,element);}
    getSectionsToRender(){return [{id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section'},{id:'CartDrawer',section:'cart-drawer',selector:'#CartDrawer'}];}
    syncOilQuantity(cart){
      const input=this.querySelector('quantity-input input');if(!input)return;
      const quantity=cart.items.filter(item=>String(item.variant_id)===String(this.dataset.index)).reduce((sum,item)=>sum+item.quantity,0);
      input.value=quantity;input.setAttribute('value',quantity);input.dataset.cartQuantity=quantity;
      this.querySelector('quantity-input')?.validateQtyRules?.();
    }
    async onCartUpdate(){const response=await fetch(`${routes.cart_url}.js`,{credentials:'same-origin'});if(!response.ok)return;this.syncOilQuantity(await response.json());}
    renderSections(state,ids){super.renderSections(state,ids);if(Array.isArray(state.items))document.querySelectorAll('nlt-context-quick-add-bulk').forEach(control=>control.syncOilQuantity(state));}
    init(){super.init();this.onCartUpdate().catch(()=>{});}
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-key-home"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-key-home')){
customElements.define('nlt-key-home',class extends HTMLElement{
connectedCallback(){
const init=()=>{
if(this.dataset.ready)return;
const form=this.querySelector('form');
if(!form)return;
this.dataset.ready='true';
form.addEventListener('formdata',event=>{
const query=form.querySelector('[name=q]').value.trim();
const brand=form.querySelector('[data-brand]').value;
const category=form.querySelector('[data-category]').value;
const exact=value=>(value.match(/"[^"]+"|\S+/g)||[]).map(term=>'"'+term.replaceAll('"','')+'"').join(' ');
const parts=[exact(query),brand?exact(brand):'',category].filter(Boolean);
if(!query&&!category)parts.unshift(this.dataset.baseQuery);
event.formData.set('q',parts.join(' '));
});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-key-quote"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-key-quote')){
customElements.define('nlt-key-quote',class extends HTMLElement{
connectedCallback(){
const initialize=()=>{
if(this.dataset.ready)return;
const form=this.querySelector('form'),button=this.querySelector('[data-quote-send]'),message=this.querySelector('[data-quote-message]');
if(!form||!button||!message)return;
this.dataset.ready='true';
const visit=form.querySelector('[data-field="visit"]'),location=form.querySelector('[data-field="location"]'),locationGroup=form.querySelector('[data-location-group]');
const update=()=>{
const home=!!visit.selectedOptions[0]?.hasAttribute('data-home-visit');
locationGroup.hidden=!home;
location.disabled=!home;
const fields=[...form.querySelectorAll('[data-label]')];
message.value=[this.dataset.message,...fields.filter(field=>!field.disabled && field.value.trim()).map(field=>field.dataset.label+': '+field.value.trim())].join('\n');
};
form.addEventListener('input',update);
form.addEventListener('change',update);
form.addEventListener('submit',()=>{update();});
button.addEventListener('click',update);
update();
button.disabled=false;
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
else initialize();
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-locksmith-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nlt-locksmith-menu')) {
 customElements.define('nlt-locksmith-menu',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;

   if(!this.classList.contains('nlt-locksmith--drawer')){
    const details=this.closest('details'),panel=this.closest('.mega-menu__content');
    if(details&&panel){
     panel.classList.add('nlt-locksmith-float');
     const overlay=document.createElement('div');overlay.className='nlt-locksmith-backdrop';overlay.hidden=true;overlay.setAttribute('aria-hidden','true');document.body.append(overlay);this.overlay=overlay;
     const media=matchMedia('(min-width:990px)');
     const position=()=>{const header=this.closest('.shopify-section');overlay.style.setProperty('--nlt-menu-top',(header?.getBoundingClientRect().bottom||0)+'px');};
     const toggle=()=>{overlay.hidden=!details.open||!media.matches;if(!overlay.hidden)position();};
     this.closeMenu=()=>{details.open=false;details.querySelector('summary')?.setAttribute('aria-expanded','false');toggle();};
     overlay.addEventListener('click',this.closeMenu);
     details.addEventListener('toggle',toggle);
     details.addEventListener('mouseenter',()=>{if(media.matches){position();overlay.hidden=false;}});
     details.addEventListener('mouseleave',toggle);
     details.addEventListener('keydown',event=>{if(event.key==='Escape'){this.closeMenu();details.querySelector('summary')?.focus();}});
     this.resizeMenu=()=>{toggle();position();};window.addEventListener('resize',this.resizeMenu);toggle();
    }
   }

   const form=this.querySelector('form');
   form.addEventListener('submit',event=>{
    event.preventDefault();
    const category=form.querySelector('[data-category]').value;
    const brand=form.querySelector('[data-brand]').value;
    const term=form.elements.q.value.trim();
    const scope=category||'(llave OR control OR carcasa OR transponder OR chip OR Lishi OR Autel OR Xhorse OR Keydiy)';
    const parts=['('+scope+')'];
    if(brand)parts.push('"'+brand.replace(/"/g,'')+'"');
    if(term)parts.push('('+term+')');
    const url=new URL(form.action,location.origin);
    url.searchParams.set('type','product');url.searchParams.set('q',parts.join(' AND '));
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview)url.searchParams.set('preview_theme_id',preview);
    location.assign(url.href);
   });
  }
  disconnectedCallback(){this.overlay?.remove();if(this.resizeMenu)window.removeEventListener('resize',this.resizeMenu);}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-manijauto-categories"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
  if(event.target.matches('select[form="NltManijautoSortForm"]'))event.target.form.requestSubmit();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-oil-catalog"] && !Shopify.designMode) return;
  try {
    function nltClassifyOil(title, t) {
  const s=title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const usage=[];
  if (/^(kit|paquete)\b/.test(s)) usage.push(t.other);
  else if (/^(aditivo|limpiador|liquido lavado)|flush|limpiador/.test(s)) usage.push(t.additives);
  else if (/anticongelante|refrigerante|coolant/.test(s)) usage.push(t.coolant);
  else if (/^filtro/.test(s)) usage.push(t.filters);
  else if (/^grasa/.test(s)) usage.push(t.grease);
  else {
    if (/transmision|transmission|\batf\b|synchromesh|powershift|supershift/.test(s)) usage.push(t.transmission);
    if (/diferencial|differencial|differential|engran|severe gear|gear lube/.test(s)) usage.push(t.differential);
    if (/aceite.*motor|motor.*aceite|\b2t\b|\b4t\b/.test(s)) usage.push(t.motor);
    if (/suspension|shock/.test(s)) usage.push(t.suspension);
  }
  if (!usage.length) usage.push(t.other);
  const lines=[[/sign[ai]ture series/,'Signature Series'],[/\boe\b/,'OE'],[/\bxl\b/,'XL'],[/dominator/,'Dominator'],[/severe gear/,'Severe Gear'],[/heavy[ -]?duty/,'Heavy-Duty'],[/premium protection/,'Premium Protection'],[/z[ -]?rod/,'Z-ROD'],[/interceptor/,'Interceptor'],[/saber/,'SABER'],[/v[ -]?twin/,'V-Twin'],[/metric motorcycle/,'Metric Motorcycle'],[/dirt bike/,'Dirt Bike'],[/atv\/utv/,'ATV/UTV'],[/synchromesh/,'Synchromesh'],[/powershift/,'Powershift'],[/super[ -]?shift/,'Super Shift'],[/grado comercial/,'Commercial Grade']];
  const line=(lines.find(([re])=>re.test(s))||[null,t.other])[1];
  const multi=[...s.matchAll(/\b(\d{1,3})\s*w\s*[-– ]?\s*(8|12|16|20|30|40|50|60|70|75|80|85|90|110|140|190|250)\b/g)].map(m=>`${Number(m[1])}W-${m[2]}`);
  const mono=s.match(/\bsae\s*(\d{2,3})\b/);
  const viscosity=multi.length?[...new Set(multi)]:[mono?`SAE ${mono[1]}`:t.unspecified];
  const measure=s.match(/\b(\d+(?:[.,]\d+)?)\s*(ml|litros?|l|kg|g)\b/);
  let size=t.unspecified;
  if (/^(kit|paquete)\b/.test(s)) size=t.kit;
  else if(measure){const raw=Number(measure[1].replace(',','.')),unit=measure[2],n=/^(l|litro|litros)$/.test(unit)&&raw===10?9.46:raw;size=/^(ml|l|litro|litros)$/.test(unit)&&[3.78,3.785].includes(n)?t.gallon:unit==='ml'&&n===946?t.quart:/^(l|litro|litros)$/.test(unit)&&n===1?t.liter:`${n} ${unit.startsWith('l')?'L':unit}`;}
  else if(/\bgal[oó]n\b/.test(s)) size=t.gallon;
  return {usage,line:[line],viscosity,size:[size]};
}
if(!customElements.get('nlt-oil-catalog')) customElements.define('nlt-oil-catalog',class extends HTMLElement{
  async connectedCallback(){
    if(this.started)return;this.started=true;
    this.t=JSON.parse(this.querySelector('[data-text]').textContent);
    this.form=this.querySelector('form');this.sort=this.querySelector('[data-sort]');this.limit=24;
    this.money=new Intl.NumberFormat(this.dataset.locale||'es-MX',{style:'currency',currency:this.dataset.currency||'MXN'});
    try{
      const fetchPage=async page=>{
        const u=new URL(this.dataset.url,location.origin);u.searchParams.set('view','nlt-oil-data');u.searchParams.set('page',page);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);
        const r=await fetch(u,{credentials:'same-origin'});if(!r.ok)throw Error('catalog');return r.json();
      };
      const first=await fetchPage(1);if(!Array.isArray(first.products))throw Error('catalog');
      const products=[...first.products];
      for(let page=2;page<=first.pages;page++){const data=await fetchPage(page);products.push(...data.products);}
      this.products=[...new Map(products.map(p=>[p.id,p])).values()].map(p=>({...p,...nltClassifyOil(p.title,this.t),availability:[p.available?'1':'0']}));
      for(const name of ['usage','line','viscosity','size','availability']){
        const container=this.form.querySelector(`[data-options="${name}"]`);
        const values=[...new Set(this.products.flatMap(p=>p[name]))].sort((a,b)=>a.localeCompare(b,'es',{numeric:true}));
        for(const value of values){
          const label=document.createElement('label');label.className='nlt-oil-checkbox';
          const input=document.createElement('input');input.type='checkbox';input.name=name;input.value=value;
          const text=document.createElement('span');text.textContent=name==='availability'?(value==='1'?this.t.available:this.t.sold_out):value;
          label.append(input,text);container.append(label);
        }
      }
      this.readURL();
      this.form.addEventListener('submit',e=>e.preventDefault());
      this.form.addEventListener('change',()=>{this.limit=24;this.render(true);});
      this.form.addEventListener('reset',()=>setTimeout(()=>{this.sort.value='featured';this.limit=24;this.render(true);},0));
      this.sort.addEventListener('change',()=>{this.limit=24;this.render(true);});
      this.querySelector('[data-more]').addEventListener('click',()=>{this.limit+=24;this.render(false);});
      this.onPop=()=>{this.readURL();this.limit=24;this.render(false);};window.addEventListener('popstate',this.onPop);
      this.render(false);
      const native=this.closest('.shopify-section').querySelector('.nlt-collection');if(native)native.remove();
      this.querySelector('[data-status]').hidden=true;this.querySelector('[data-interface]').hidden=false;
    }catch(error){this.querySelector('[data-status]').textContent=this.t.error;}
  }
  disconnectedCallback(){window.removeEventListener('popstate',this.onPop);}
  readURL(){
    const p=new URL(location.href).searchParams;
    for(const field of this.form.elements){
      if(!field.name)continue;
      if(field.type==='checkbox'){
        const values=p.getAll('oil_'+field.name).map(value=>{
          if(field.name!=='size')return value;
          if(/^3[.,]78(?:5)?\s*(?:ml|l)$/i.test(value.trim())||value==='Galón (3.785 L)')return this.t.gallon;
          if(value==='Cuarto (946 ml)')return this.t.quart;
          if(value==='Litro (1 L)')return this.t.liter;
          if(/^10\s*l$/i.test(value.trim()))return '9.46 L';
          return value;
        });
        if(!values.length&&field.name==='availability')values.push(...p.getAll('filter.v.availability'));
        field.checked=values.includes(field.value);
        if(field.checked)field.closest('details').open=true;
      }else field.value=p.get('oil_'+field.name)||(field.name==='min'?p.get('filter.v.price.gte'):field.name==='max'?p.get('filter.v.price.lte'):'')||'';
    }
    this.sort.value=p.get('oil_sort')||'featured';
  }
  render(updateURL){
    const data=new FormData(this.form),keys=['usage','line','viscosity','size','availability'];
    const state=Object.fromEntries(keys.map(k=>[k,data.getAll(k)]));
    state.min=data.get('min')||'';state.max=data.get('max')||'';
    for(const k of keys){this.querySelector(`[data-selection-count="${k}"]`).textContent=state[k].length?` (${state[k].length})`:'';}
    if(updateURL){
      const u=new URL(location.href);
      for(const[k,v]of Object.entries(state)){u.searchParams.delete('oil_'+k);for(const value of Array.isArray(v)?v:[v])if(value!=='')u.searchParams.append('oil_'+k,value);}
      this.sort.value==='featured'?u.searchParams.delete('oil_sort'):u.searchParams.set('oil_sort',this.sort.value);
      u.searchParams.delete('page');for(const key of ['filter.v.price.gte','filter.v.price.lte','filter.v.availability'])u.searchParams.delete(key);history.pushState({},'',u);
    }
    let selected=this.products.filter(p=>keys.every(k=>!state[k].length||state[k].some(v=>p[k].includes(v)))&&(state.min===''||p.price>=Number(state.min)*100)&&(state.max===''||p.price<=Number(state.max)*100));
    if(this.sort.value==='price_up')selected.sort((a,b)=>a.price-b.price);if(this.sort.value==='price_down')selected.sort((a,b)=>b.price-a.price);if(this.sort.value==='az')selected.sort((a,b)=>a.title.localeCompare(b.title));
    this.querySelector('[data-count]').textContent=`${selected.length} ${this.t.results}`;
    const chips=this.querySelector('[data-chips]');chips.replaceChildren();
    for(const[k,values]of Object.entries(state)){
      for(const v of Array.isArray(values)?values:[values]){
        if(v==='')continue;
        const b=document.createElement('button');b.type='button';
        let label=k==='availability'?(v==='1'?this.t.available:this.t.sold_out):v;
        if(k==='min'||k==='max')label=`${k==='min'?this.t.from:this.t.to}: ${this.money.format(Number(v))}`;
        else label=`${this.t[k]}: ${label}`;
        b.textContent=label+' ×';
        b.addEventListener('click',()=>{
          for(const field of this.form.elements){if(field.name!==k)continue;if(field.type==='checkbox'){if(field.value===v)field.checked=false;}else field.value='';}
          this.limit=24;this.render(true);
        });chips.append(b);
      }
    }
    const grid=this.querySelector('[data-products]');grid.replaceChildren();
    for(const p of selected.slice(0,this.limit)){
      const card=document.createElement('div');card.className='nlt-oil-native-card';
      card.innerHTML=p.card.replaceAll('<quick-add-bulk','<nlt-oil-quick-add-bulk').replaceAll('</quick-add-bulk>','</nlt-oil-quick-add-bulk>');
      for(const control of card.querySelectorAll('nlt-oil-quick-add-bulk'))control.id=`nlt-oil-quantity-${p.id}`;
      grid.append(card);
    }
    this.querySelector('[data-empty]').hidden=selected.length>0;this.querySelector('[data-more]').hidden=selected.length<=this.limit;
  }
});

customElements.whenDefined('quick-add-bulk').then(()=>{
  if(customElements.get('nlt-oil-quick-add-bulk'))return;
  customElements.define('nlt-oil-quick-add-bulk',class extends customElements.get('quick-add-bulk'){
    sendRequest(queue,element){this.requestStarted=true;const items={};for(const item of queue)items[item.id]=item.quantity;this.queue=this.queue.filter(item=>!queue.includes(item));this.updateMultipleQty(items,element);}
    getSectionsToRender(){return [{id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section'},{id:'CartDrawer',section:'cart-drawer',selector:'#CartDrawer'}];}
    syncOilQuantity(cart){
      const input=this.querySelector('quantity-input input');if(!input)return;
      const quantity=cart.items.filter(item=>String(item.variant_id)===String(this.dataset.index)).reduce((sum,item)=>sum+item.quantity,0);
      input.value=quantity;input.setAttribute('value',quantity);input.dataset.cartQuantity=quantity;
      this.querySelector('quantity-input')?.validateQtyRules?.();
    }
    async onCartUpdate(){const response=await fetch(`${routes.cart_url}.js`,{credentials:'same-origin'});if(!response.ok)return;this.syncOilQuantity(await response.json());}
    renderSections(state,ids){super.renderSections(state,ids);if(Array.isArray(state.items))document.querySelectorAll('nlt-oil-quick-add-bulk').forEach(control=>control.syncOilQuantity(state));}
    init(){super.init();this.onCartUpdate().catch(()=>{});}
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-product-delivery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-live-delivery'))customElements.define('nlt-live-delivery',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.version=0;
  this.status=this.querySelector('.nlt-live-status');this.rates=this.querySelector('.nlt-live-rates');this.button=this.querySelector('.nlt-calculate');
  const pickup=this.closest('product-info')?.querySelector('pickup-availability'),slot=this.querySelector('.nlt-pickup-slot');
  if(pickup&&slot){slot.append(pickup);slot.hidden=false;}
  this.button.addEventListener('click',()=>this.calculate());
  this.querySelectorAll('input,select').forEach(el=>{el.addEventListener('input',()=>this.invalidate());el.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();this.calculate();}});});
  this.productRoot=this.closest('section')||document;
  this.onChange=e=>{if(!this.contains(e.target)&&e.target.matches('input,select'))this.invalidate();};this.productRoot.addEventListener('change',this.onChange);
  this.clock=setInterval(()=>this.updateLocalDates(),30000);this.onCart=()=>this.invalidate();document.addEventListener('cart:updated',this.onCart);
 }
 disconnectedCallback(){clearInterval(this.clock);this.controller?.abort();this.productRoot?.removeEventListener('change',this.onChange);document.removeEventListener('cart:updated',this.onCart);}
 msg(key){return this.querySelector('[data-message="'+key+'"]').textContent;}
 invalidate(){this.version++;this.controller?.abort();this.button.disabled=false;if(this.rates.children.length||this.status.textContent){this.rates.replaceChildren();this.status.textContent=this.msg('changed');}}
 localDate(now=new Date()){
  const parts=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:'America/Chihuahua',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
  const date=new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day),12));
  const weekday=date.getUTCDay();
  if(weekday>=1&&weekday<=5&&Number(parts.hour)<12)return this.msg('local_today');
  do{date.setUTCDate(date.getUTCDate()+1);}while(date.getUTCDay()===0||date.getUTCDay()===6);
  return this.msg('local_next').replace('[fecha]',new Intl.DateTimeFormat('es-MX',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(date));
 }
 updateLocalDates(){this.querySelectorAll('[data-local-date]').forEach(el=>el.textContent=this.localDate());}
 async calculate(){
  if(![...this.querySelectorAll('input')].every(el=>el.reportValidity()))return;
  this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;const version=++this.version;
  this.button.disabled=true;this.rates.replaceChildren();this.status.textContent=this.msg('loading');
  try{
   const val=name=>this.querySelector('[name="'+name+'"]').value.trim();let items,discount_codes=[];
   if(val('scope')==='cart'){
    const res=await fetch(this.dataset.root+'cart.js',{signal,headers:{Accept:'application/json'},cache:'no-store'});if(!res.ok)throw Error(this.msg('error'));const cart=await res.json();
    if(!cart.items?.length)throw Error(this.msg('empty'));
    if(cart.items.some(i=>i.selling_plan_allocation))throw Error(this.msg('unsupported'));
    items=cart.items.map(i=>({variant_id:String(i.variant_id),quantity:i.quantity}));discount_codes=(cart.discount_codes||[]).filter(d=>d.applicable).map(d=>d.code);
   }else{
    const form=this.productRoot.querySelector('form[action*="/cart/add"]');
    const variant=form?.querySelector('[name="id"]')?.value||this.dataset.variant;
    const qty=this.productRoot.querySelector('[name="quantity"]')?.value||1;
    if(form?.querySelector('[name="selling_plan"]')?.value)throw Error(this.msg('unsupported'));
    items=[{variant_id:variant,quantity:Number(qty)}];
   }
   const response=await fetch(this.dataset.root+'apps/nlt-taller/delivery/quote',{method:'POST',signal,headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,discount_codes,address:{zip:val('zip')}})});
   const data=await response.json();if(version!==this.version)return;if(!response.ok||!data.ok)throw Error(data.error||this.msg('error'));
   this.status.textContent=this.msg(data.rates.length?'success':'no_rates');
   for(const rate of data.rates){const row=document.createElement('div'),info=document.createElement('div'),title=document.createElement('h4'),kind=document.createElement('small'),price=document.createElement('strong');title.textContent=rate.kind==='local'?this.msg('local'):rate.title;kind.textContent=this.msg(rate.kind==='local'?'local':'shipping');price.textContent=new Intl.NumberFormat('es-MX',{style:'currency',currency:rate.currency}).format(Number(rate.amount))+' '+rate.currency;info.append(title,kind);if(rate.kind==='local'){kind.textContent=this.msg('local_schedule');const eta=document.createElement('p');eta.setAttribute('data-local-date','');eta.className='nlt-local-date';eta.textContent=this.localDate();info.append(eta);}row.append(info,price);this.rates.append(row);}
  }catch(error){if(version===this.version&&error.name!=='AbortError')this.status.textContent=error.message||this.msg('error');}
  finally{if(version===this.version)this.button.disabled=false;}
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-product-detail-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nlt-product-tabs')) {
  customElements.define('nlt-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      const selected = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      select(selected < 0 ? 0 : selected);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-product-reviews"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nlt-review-form').forEach(details=>{if(details.querySelector('[role="status"],.errors'))details.open=true;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-quick-label"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nlt-quick-label')) customElements.define('nlt-quick-label', class extends HTMLElement {
connectedCallback() {
 if(this.ready)return;this.ready=true;
 const form=this.querySelector('form'),label=this.querySelector('.nlt-quick-sticker'),status=this.querySelector('[data-label-status]');
 const isoLocal=date=>[date.getFullYear(),String(date.getMonth()+1).padStart(2,'0'),String(date.getDate()).padStart(2,'0')].join('-');
 const oneYear=value=>{
 const [year,month,day]=value.split('-').map(Number);
 if(!year||!month||!day)return '';
 const last=new Date(year+1,month,0).getDate();
 return [year+1,String(month).padStart(2,'0'),String(Math.min(day,last)).padStart(2,'0')].join('-');
 };
 const fitLabel=paper=>{
 paper.style.height='auto';
 paper.querySelectorAll('.nlt-quick-sticker__row strong').forEach(value=>{
 let size=value.closest('.nlt-quick-sticker__next')?9:8.5;
 value.style.fontSize=size+'pt';
 while(value.clientWidth>0&&value.scrollWidth>value.clientWidth+1&&size>5.5){size-=.1;value.style.fontSize=size+'pt';}
 });
 const heightMM=Math.max(35,Math.ceil((paper.getBoundingClientRect().height/3.7795275591-.05)/5)*5);
 paper.style.height=heightMM+'mm';
 return heightMM;
 };
 let layoutFrame;
 const scheduleLayout=()=>{
 cancelAnimationFrame(layoutFrame);
 layoutFrame=requestAnimationFrame(()=>{
 if(!this.querySelector('details').open)return;
 this.querySelector('[data-quick-size]').textContent=fields.paper_width.value+' × '+fitLabel(label)+' mm';
 });
 };
 this.querySelector('details').addEventListener('toggle',scheduleLayout);
 document.fonts.ready.then(scheduleLayout);
 const fields=form.elements;
 fields.current_date.value=isoLocal(new Date());
 fields.date.value=oneYear(fields.current_date.value);
 fields.unit.value='mi';
 let automaticNextDate=fields.date.value;
 fields.current_date.addEventListener('change',()=>{
 if(!fields.date.value||fields.date.value===automaticNextDate){
 automaticNextDate=oneYear(fields.current_date.value);fields.date.value=automaticNextDate;
 }
 });
 const update=()=>{
 const f=form.elements,d=f.date.value.split('-');
 label.dataset.paperWidth=f.paper_width.value;
 label.style.width=f.paper_width.value+'mm';
 f.odometer.min=f.current_odometer.value!==''?String(Number(f.current_odometer.value)+1):'0';
 f.date.min=f.current_date.value;
 label.querySelector('[data-label-current-date]').textContent=f.current_date.value?f.current_date.value.split('-').reverse().join('/'):'—';
 label.querySelector('[data-label-current-mileage]').textContent=f.current_odometer.value!==''?Number(f.current_odometer.value).toLocaleString('es-MX')+' '+f.unit.value:'—';

 label.querySelector('[data-label-vehicle]').textContent=f.vehicle.value.trim();
 label.querySelector('[data-label-oil]').textContent=f.oil.value.trim();
 label.querySelectorAll('[data-filter-row]').forEach(row=>{
 const value=f[row.dataset.filterRow].value.trim();
 row.hidden=!value;
 row.querySelector('[data-filter-value]').textContent=value;
 });
 label.querySelector('[data-label-date]').textContent=d.length===3?d.reverse().join('/'):'—';
 label.querySelector('[data-label-odometer]').textContent=f.odometer.value!==''?Number(f.odometer.value).toLocaleString('es-MX')+' '+f.unit.value:'—';
 label.dataset.monochrome=String(f.monochrome.checked);
 label.querySelector('.nlt-quick-sticker__materials').hidden=!f.oil.value.trim()&&![...label.querySelectorAll('[data-filter-row]')].some(row=>!row.hidden);
 scheduleLayout();
 };
 update();
 form.addEventListener('input',update);form.addEventListener('change',update);
 form.addEventListener('submit',event=>{
 event.preventDefault();update();if(!form.reportValidity())return;
 status.textContent='';
 const widthMM=Number(fields.paper_width.value);
 const win=window.open('','_blank','width=600,height=650');
 if(!win){status.textContent=status.dataset.blocked;return;}
 win.opener=null;
 const doc=win.document;
 doc.open();doc.write('<!doctype html><html lang="es"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body></body></html>');doc.close();
 doc.title='NLT · Etiqueta';
 const style=doc.createElement('style');
 style.textContent=".nlt-quick-sticker{--quick-bg:#101315;--quick-ink:#fff;--quick-muted:#d9dfe3;--quick-red:#ed1c24;--quick-panel:#22282d;box-sizing:border-box;width:50mm;min-height:35mm;height:auto;padding:1.4mm 1.5mm;border:.35mm solid var(--quick-red);border-radius:2mm;background-color:var(--quick-bg);background-image:linear-gradient(135deg,transparent 65%,#ffffff06 65%,#ffffff06 80%,transparent 80%);color:var(--quick-ink);font:6pt/1.15 Arial,sans-serif;overflow:visible;text-align:left;-webkit-print-color-adjust:exact;print-color-adjust:exact}\n.nlt-quick-sticker *{box-sizing:border-box}\n.nlt-quick-sticker img{display:block;width:27mm;height:8mm;object-fit:contain;margin:0 auto .9mm;padding:.4mm .6mm;border-radius:.8mm;background:#fff;max-width:none}\n.nlt-quick-sticker__vehicle{font-size:7.2pt;font-weight:800;text-align:center;line-height:1.12;overflow-wrap:anywhere;text-transform:uppercase;margin:0 0 1mm}\n.nlt-quick-sticker__current,.nlt-quick-sticker__next{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.7mm 1.3mm;padding:1mm;border-radius:1mm;margin:0 0 1mm}\n.nlt-quick-sticker__current{background:var(--quick-panel);border:.15mm solid var(--quick-muted)}\n.nlt-quick-sticker__next{border:.3mm solid var(--quick-red)}\n.nlt-quick-sticker h3{grid-column:1/-1;font:800 6pt/1.1 Arial,sans-serif!important;letter-spacing:.1mm;margin:0!important;padding:0 0 .5mm!important;color:var(--quick-ink)!important;text-align:left}\n.nlt-quick-sticker__next h3{margin:-1mm -1mm .1mm!important;padding:.8mm 1mm!important;background:var(--quick-red);color:#fff!important;border-radius:.6mm .6mm 0 0}\n.nlt-quick-sticker__row{display:flex;min-width:0;flex-direction:column;gap:.4mm;margin:0}\n.nlt-quick-sticker__row span{font-size:4.6pt;font-weight:600;color:var(--quick-muted);line-height:1.1}\n.nlt-quick-sticker__row strong{display:block;width:100%;font-size:8.5pt;font-weight:800;line-height:1.1;white-space:nowrap;color:var(--quick-ink)}\n.nlt-quick-sticker__next .nlt-quick-sticker__row strong{font-size:9pt}\n.nlt-quick-sticker small{grid-column:1/-1;display:block;text-align:left;font-size:4.5pt;line-height:1.1;color:var(--quick-muted);margin:.2mm 0 0}\n.nlt-quick-sticker__materials{margin:1mm 0;padding:.7mm 0 0;border-top:.15mm solid var(--quick-muted)}\n.nlt-quick-sticker__oil{font-size:6.2pt;font-weight:700;line-height:1.2;margin:0 0 .6mm;overflow-wrap:anywhere;color:var(--quick-ink)}\n.nlt-quick-sticker__filters{font-size:5.2pt;line-height:1.2;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:1mm;border-bottom:.1mm solid var(--quick-muted);padding:.55mm 0;color:var(--quick-muted)}\n.nlt-quick-sticker__filters strong{font-size:6pt;line-height:1.2;text-align:right;overflow-wrap:anywhere;min-width:0;color:var(--quick-ink)}\n.nlt-quick-sticker footer{font:800 5.5pt/1.1 Arial,sans-serif;text-align:center;color:var(--quick-ink);border-top:.4mm solid var(--quick-red);padding-top:.8mm;margin-top:.7mm;letter-spacing:.1mm}\n.nlt-quick-sticker [hidden],.nlt-quick-sticker__vehicle:empty,.nlt-quick-sticker__oil:empty{display:none!important}\n.nlt-quick-sticker[data-monochrome=true]{--quick-bg:#fff;--quick-ink:#111;--quick-muted:#333;--quick-red:#111;--quick-panel:#f0f0f0;background-image:none}\n.nlt-quick-sticker[data-monochrome=true] img{filter:grayscale(1)}"+'@page{size:50mm 35mm;margin:0}html,body{margin:0;padding:0}body{background:#edf0f2;font-family:Arial,sans-serif}.nlt-quick-sticker{margin:24px auto;box-shadow:0 4px 20px #0002}.toolbar{padding:20px;text-align:center}button{background:#bd1d2c;color:white;border:0;border-radius:6px;padding:14px 28px;font-size:18px;cursor:pointer}button:disabled{opacity:.5}p{font-size:14px;line-height:1.5}@media print{html,body{width:50mm;height:35mm;background:white}.toolbar{display:none!important}.nlt-quick-sticker{margin:0;box-shadow:none;break-inside:avoid;print-color-adjust:exact;-webkit-print-color-adjust:exact}}';
 style.textContent+=".nlt-quick-sticker[data-paper-width=\"25\"] img{width:100%;height:8mm}.nlt-quick-sticker[data-paper-width=\"25\"] .nlt-quick-sticker__current,.nlt-quick-sticker[data-paper-width=\"25\"] .nlt-quick-sticker__next{grid-template-columns:1fr}.nlt-quick-sticker[data-paper-width=\"25\"] .nlt-quick-sticker__filters{grid-template-columns:1fr;gap:.3mm}.nlt-quick-sticker[data-paper-width=\"25\"] .nlt-quick-sticker__filters strong{text-align:left}";
 doc.head.appendChild(style);
 const toolbar=doc.createElement('div');toolbar.className='toolbar';
 const print=doc.createElement('button');print.textContent=status.dataset.print;print.disabled=true;
 const help=doc.createElement('p');help.textContent=status.dataset.loading;help.setAttribute('role','status');
 toolbar.append(print,help);doc.body.append(toolbar,label.cloneNode(true));
 print.addEventListener('click',()=>{win.focus();win.print();});
 const image=doc.querySelector('img');
 Promise.race([image.decode(),new Promise((_,reject)=>setTimeout(()=>reject(Error('image')),10000))]).then(()=>doc.fonts.ready).then(()=>{
 const sticker=doc.querySelector('.nlt-quick-sticker');
 const heightMM=fitLabel(sticker);
 if([...sticker.querySelectorAll('.nlt-quick-sticker__row strong')].some(value=>value.scrollWidth>value.clientWidth+1)){help.textContent=status.dataset.fitError;status.textContent=status.dataset.fitError;return;}
 const sizeStyle=doc.createElement('style');
 sizeStyle.textContent='@page{size:'+widthMM+'mm '+heightMM+'mm;margin:0}@media print{html,body{width:'+widthMM+'mm;height:'+heightMM+'mm}.nlt-quick-sticker{height:'+heightMM+'mm}}';
 doc.head.appendChild(sizeStyle);
 help.textContent=widthMM+' × '+heightMM+' mm · '+this.querySelector('.nlt-quick__hint').textContent;
 print.disabled=false;status.textContent=status.dataset.ready;
 }).catch(()=>{help.textContent=status.dataset.error;status.textContent=status.dataset.error;});
 });

}

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-quote-racing"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = ':is(.mprfq-show-desktop,.mprfq-show-mobile)[aria-label="SP Request a Quote (RFQ)"]';
  const key = 'nlt-quote-position-v1';
  let saved;
  try { saved = JSON.parse(localStorage.getItem(key)); } catch {}
  if (!saved || !Number.isFinite(saved.x) || !Number.isFinite(saved.y)) saved = null;
  const viewport = () => ({x: window.visualViewport?.offsetLeft || 0, y: window.visualViewport?.offsetTop || 0, w: window.visualViewport?.width || innerWidth, h: window.visualViewport?.height || innerHeight});
  const place = (root, x, y) => {
    const v = viewport(), r = root.getBoundingClientRect();
    const maxX = Math.max(0, v.w - r.width - 16), maxY = Math.max(0, v.h - r.height - 16);
    const px = Math.max(0, Math.min(maxX, x)), py = Math.max(0, Math.min(maxY, y));
    root.style.setProperty('--nlt-quote-x', (v.x + 8 + px) + 'px');
    root.style.setProperty('--nlt-quote-y', (v.y + 8 + py) + 'px');
    root.dataset.nltPositioned = '';
    return {x: maxX ? px / maxX : 0, y: maxY ? py / maxY : 0};
  };
  const restore = root => {
    if (!saved || !root.getClientRects().length) return;
    const v = viewport(), r = root.getBoundingClientRect();
    place(root, saved.x * Math.max(0, v.w - r.width - 16), saved.y * Math.max(0, v.h - r.height - 16));
  };
  const persist = position => {
    saved = position;
    try { localStorage.setItem(key, JSON.stringify(saved)); } catch {}
    document.querySelectorAll(selector).forEach(restore);
  };
  const bind = root => {
    const button = root.querySelector('[role="button"][aria-label="Open quotes"]');
    if (!button || button.dataset.nltMovable) return;
    button.dataset.nltMovable = 'true';
    let drag, suppressUntil = 0;
    button.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0) return;
      const rect = root.getBoundingClientRect();
      drag = {id:event.pointerId, x:event.clientX, y:event.clientY, left:rect.left, top:rect.top, moved:false};
      button.setPointerCapture(event.pointerId);
    });
    button.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId) return;
      const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if (!drag.moved && Math.hypot(dx, dy) < 8) return;
      drag.moved = true;
      root.dataset.nltDragging = '';
      const v = viewport();
      drag.position = place(root, drag.left + dx - v.x - 8, drag.top + dy - v.y - 8);
      event.preventDefault();
    });
    const finish = event => {
      if (!drag || drag.id !== event.pointerId) return;
      if (drag.moved) { suppressUntil = Date.now() + 500; persist(drag.position); }
      drag = null;
      delete root.dataset.nltDragging;
      if (button.hasPointerCapture(event.pointerId)) button.releasePointerCapture(event.pointerId);
    };
    button.addEventListener('pointerup', finish);
    button.addEventListener('pointercancel', finish);
    button.addEventListener('lostpointercapture', finish);
    window.addEventListener('click', event => {
      if (Date.now() < suppressUntil && root.contains(event.target)) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    }, true);
    button.addEventListener('keydown', event => {
      if (!event.altKey || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) return;
      event.preventDefault(); event.stopPropagation();
      const r = root.getBoundingClientRect(), v = viewport();
      const dx = event.key === 'ArrowLeft' ? -20 : event.key === 'ArrowRight' ? 20 : 0;
      const dy = event.key === 'ArrowUp' ? -20 : event.key === 'ArrowDown' ? 20 : 0;
      persist(place(root, r.left - v.x - 8 + dx, r.top - v.y - 8 + dy));
    });
    restore(root);
  };
  const scan = () => document.querySelectorAll(selector).forEach(bind);
  scan();
  new MutationObserver(scan).observe(document.documentElement, {childList:true, subtree:true});
  const resize = () => document.querySelectorAll(selector).forEach(restore);
  window.addEventListener('resize', resize);
  window.visualViewport?.addEventListener('resize', resize);
  window.visualViewport?.addEventListener('scroll', resize);
  if (window.matchMedia) window.matchMedia('(max-width:749px)').addEventListener('change', resize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-search-categories"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
 const link=event.target.closest('a[data-nlt-category-target]');
 if(!link)return;
 const url=new URL(window.location.href);
 url.searchParams.set('q',link.dataset.nltCategoryTarget);
 url.searchParams.set('type','product');
 url.searchParams.delete('page');
 link.href=url.toString();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-shop-tools"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-shop-tools')){
const saved={favorite:[],compare:[]};
const account=document.querySelector('nlt-shop-tools')?.dataset.customer||'';
for(const key of Object.keys(saved)){if(key==='favorite'&&account)continue;try{const data=JSON.parse(localStorage.getItem('nlt-products-'+key)||'[]');if(Array.isArray(data))saved[key]=data.filter(p=>p&&typeof p.id==='string'&&typeof p.title==='string'&&typeof p.url==='string'&&p.url.startsWith('/')&&!p.url.startsWith('//')).slice(0,key==='compare'?3:100);}catch{}}
function sync(){for(const key of Object.keys(saved)){try{if(key!=='favorite'||!account)localStorage.setItem('nlt-products-'+key,JSON.stringify(saved[key]));}catch{}document.querySelectorAll('[data-count="'+key+'"]').forEach(el=>el.textContent=saved[key].length);}document.querySelectorAll('nlt-shop-card').forEach(card=>card.querySelectorAll('[data-action]').forEach(b=>{const selected=saved[b.dataset.action].some(p=>p.id===card.dataset.id);b.setAttribute('aria-pressed',String(selected));b.querySelector('span').textContent=b.dataset.action==='favorite'?(selected?'♥':'♡'):(selected?'☑':'☐');}));}
function element(tag,text){const el=document.createElement(tag);if(text!==undefined)el.textContent=text;return el;}
customElements.define('nlt-shop-tools',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.dialog=this.querySelector('dialog');this.toolbar=this.querySelector('.nlt-tools');const place=()=>{const mobile=matchMedia('(max-width:989px)').matches;const target=document.querySelector(mobile?'.menu-drawer__navigation':'#announcement_navigation')||document.querySelector('.header__icons');if(target){target.append(this.toolbar);this.toolbar.hidden=false;}};place();matchMedia('(max-width:989px)').addEventListener('change',place);document.addEventListener('click',e=>{const open=e.target.closest('.nlt-tools [data-open]');if(open){this.mode=open.dataset.open;this.render();this.dialog.showModal();}if(e.target.closest('[data-close]'))this.dialog.close();});sync();this.pending=Promise.resolve();this.syncState=account?'syncing':'local';this.boot=account?this.refresh():Promise.resolve();window.addEventListener('focus',()=>{if(account&&!this.busy)this.boot=this.refresh();});}
async request(method,p){
 const response=await fetch('/apps/nlt-taller/favorites',{method,credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json',...(method==='POST'?{'X-CSRF-Token':this.csrf}:{})},...(p?{body:JSON.stringify(p)}:{}),signal:AbortSignal.timeout(15000)});
 if(!response.ok)throw Error('sync');const data=await response.json();if(!data.ok||data.customer_id!==account||!Array.isArray(data.items))throw Error('identity');if(data.csrf_token)this.csrf=data.csrf_token;return data;
}
async refresh(){
 this.busy=true;this.syncState='syncing';this.update();
 try{let data=await this.request('GET');let guest=[];try{guest=JSON.parse(localStorage.getItem('nlt-products-favorite')||'[]');}catch{}
 if(Array.isArray(guest)&&guest.length){const ids=[...new Set(guest.map(p=>p?.id).filter(id=>typeof id==='string'&&/^[1-9][0-9]{0,19}$/.test(id)))].slice(0,100);if(ids.length)data=await this.request('POST',{action:'merge',ids});try{const now=JSON.parse(localStorage.getItem('nlt-products-favorite')||'[]');localStorage.setItem('nlt-products-favorite',JSON.stringify(now.filter(p=>!ids.includes(p.id))));}catch{}}
 saved.favorite=data.items;this.lists=Array.isArray(data.lists)?data.lists:[];this.syncState='account';
 }catch{saved.favorite=[];this.syncState='sync_error';}finally{this.busy=false;sync();this.update();}
}
update(){if(this.dialog.open&&this.mode==='favorite')this.render();document.querySelectorAll('[data-action="favorite"]').forEach(b=>b.disabled=!!this.busy);}
changeFavorite(product,remove=false){
 if(!account){if(remove)saved.favorite=saved.favorite.filter(p=>p.id!==product.id);else if(!saved.favorite.some(p=>p.id===product.id)){if(saved.favorite.length>=100)return;saved.favorite.push(product);}sync();this.update();return;}
 this.pending=this.pending.then(async()=>{await this.boot;if(this.syncState!=='account'){await this.refresh();if(this.syncState!=='account')return;}this.busy=true;this.update();try{const data=await this.request('POST',{action:remove?'remove':'add',ids:[product.id]});saved.favorite=data.items;this.lists=Array.isArray(data.lists)?data.lists:[];this.syncState='account';}catch{this.syncState='sync_error';}finally{this.busy=false;sync();this.update();}});
}

changeList(payload){
 this.pending=this.pending.then(async()=>{
  await this.boot;if(this.syncState!=='account'){await this.refresh();if(this.syncState!=='account')return;}
  this.busy=true;this.update();
  try{const data=await this.request('POST',payload);saved.favorite=data.items;this.lists=data.lists||[];this.syncState='account';this.listEditor=null;if(this.activeList&&!this.lists.some(l=>l.id===this.activeList)&&this.activeList!=='unassigned')this.activeList='';}
  catch{this.syncState='sync_error';}
  finally{this.busy=false;sync();this.update();}
 });
}
listControls(content){
 const l=this.labels,lists=this.lists||[];
 const bar=element('div');bar.className='nlt-list-controls';
 const filter=element('select');filter.setAttribute('aria-label',l.lists_all);
 filter.append(new Option(l.lists_all,''),new Option(l.lists_none,'unassigned'));
 const groups=new Map();for(const list of lists){const category=list.category||l.lists_general;if(!groups.has(category)){const group=element('optgroup');group.label=category;groups.set(category,group);filter.append(group);}groups.get(category).append(new Option(list.name+' ('+list.ids.length+')',list.id));}
 filter.value=this.activeList||'';filter.disabled=!!this.busy;filter.onchange=()=>{this.activeList=filter.value;this.listEditor=null;this.render();};bar.append(filter);
 const create=element('button',l.lists_new);create.type='button';create.disabled=!!this.busy;create.onclick=()=>{this.listEditor={name:'',category:''};this.render();};bar.append(create);
 const current=lists.find(x=>x.id===this.activeList);
 if(current){const edit=element('button',l.lists_edit);edit.type='button';edit.disabled=!!this.busy;edit.onclick=()=>{this.listEditor={...current};this.render();};bar.append(edit);}
 content.append(bar,element('p',l.lists_hint));
 if(this.listEditor){
  const editor=element('form');editor.className='nlt-list-editor';const draft=this.listEditor;
  const field=(key,value)=>{const label=element('label',l[key]),input=element('input');input.type='text';input.maxLength=60;input.value=value;input.required=key==='lists_name';input.disabled=!!this.busy;label.append(input);editor.append(label);return input;};
  const name=field('lists_name',draft.name),category=field('lists_category',draft.category);
  const save=element('button',l.lists_save);save.type='submit';save.disabled=!!this.busy;
  const cancel=element('button',l.lists_cancel);cancel.type='button';cancel.disabled=!!this.busy;cancel.onclick=()=>{this.listEditor=null;this.render();};editor.append(save,cancel);
  if(draft.id){const del=element('button',l.lists_delete);del.type='button';del.disabled=!!this.busy;del.onclick=()=>{if(confirm(l.lists_delete_confirm))this.changeList({action:'delete_list',list_id:draft.id});};editor.append(del);}
  editor.onsubmit=e=>{e.preventDefault();this.changeList({action:draft.id?'edit_list':'create_list',...(draft.id?{list_id:draft.id}:{}),name:name.value.trim(),category:category.value.trim()});};content.append(editor);
 }
}
productDetails(p){
 this.productCache ||= new Map();
 if(!this.productCache.has(p.url)){
  const url=new URL(p.url,location.origin);
  if(url.origin!==location.origin||!url.pathname.includes('/products/'))return Promise.resolve(null);
  this.productCache.set(p.url,fetch(url.pathname+'.js',{credentials:'same-origin',signal:AbortSignal.timeout(8000)}).then(r=>r.ok?r.json():null).then(data=>data&&String(data.id)===String(p.id)?data:null).catch(()=>null));
 }
 return this.productCache.get(p.url);
}
render(){const key=this.mode,l=this.labels,content=this.querySelector('.nlt-dialog-content');let items=saved[key];content.replaceChildren();this.querySelector('.nlt-saved-total').textContent=items.length;this.querySelector('h2').textContent=l[key];this.querySelector('.nlt-dialog-note').textContent=key==='favorite'?(l[this.syncState]||l.local):l.choose;
const link=p=>{const a=element('a',p.title);a.href=p.url;return a;};const remove=p=>{const b=element('button',l.remove);b.setAttribute('aria-label',l.remove+' '+p.title);b.disabled=key==='favorite'&&!!this.busy;b.onclick=()=>{if(key==='favorite'){this.changeFavorite(p,true);return;}saved[key]=saved[key].filter(x=>x.id!==p.id);sync();this.render();};return b;};
if(key==='favorite'&&!account){const login=element('a',l.sign_in);login.href=this.dataset.login;content.append(login);}if(key==='favorite'&&this.syncState==='sync_error'){const retry=element('button',l.retry);retry.onclick=()=>{this.boot=this.refresh();};content.append(retry);return;}
if(key==='favorite'&&account&&this.syncState==='account'){this.listControls(content);const lists=this.lists||[];if(this.activeList==='unassigned')items=items.filter(p=>!lists.some(list=>list.ids.includes(p.id)));else if(this.activeList){const list=lists.find(x=>x.id===this.activeList);if(list)items=items.filter(p=>list.ids.includes(p.id));}this.querySelector('.nlt-saved-total').textContent=items.length;}
if(key==='favorite'&&!account)content.append(element('p',l.lists_login));
if(!items.length){content.append(element('p',key==='favorite'&&this.activeList?l.lists_empty:l.empty));return;}
if(key==='favorite'){
 const ul=element('ul');ul.className='nlt-favorites-list';
 items.forEach(p=>{
  const li=element('li');li.className='nlt-favorite-card';
  const photo=element('a','♡');photo.className='nlt-favorite-photo';photo.href=p.url;photo.setAttribute('aria-label',p.title);
  const info=element('div');info.className='nlt-favorite-info';
  const title=link(p);title.className='nlt-favorite-title';
  const actions=element('div');actions.className='nlt-favorite-actions';
  const view=element('a',l.view);view.href=p.url;view.className='nlt-favorite-view';
  const del=remove(p);del.className='nlt-favorite-remove';
  actions.append(view,del);info.append(title,actions);
  if(account){const label=element('label',l.lists_move);label.className='nlt-list-assignment';const select=element('select');select.append(new Option(l.lists_none,''));for(const list of this.lists||[])select.append(new Option((list.category?list.category+' · ':'')+list.name,list.id));select.value=(this.lists||[]).find(list=>list.ids.includes(p.id))?.id||'';select.disabled=!!this.busy;select.onchange=()=>this.changeList({action:'assign_list',list_id:select.value,product_id:p.id});label.append(select);info.append(label);}li.append(photo,info);ul.append(li);
  this.productDetails(p).then(data=>{
   if(!data||!li.isConnected)return;
   if(data.featured_image){const img=element('img');img.alt=data.title;img.loading='lazy';img.src=data.featured_image;photo.replaceChildren(img);}
   if(data.vendor){const brand=element('span',data.vendor);brand.className='nlt-favorite-brand';info.prepend(brand);}
   if(Number.isFinite(data.price)){const price=element('span',(data.price===0||data.price===100)?l.consult:new Intl.NumberFormat(this.dataset.locale||'es-MX',{style:'currency',currency:this.dataset.currency||'MXN'}).format(data.price/100));if((data.price===0||data.price===100))view.textContent=l.quote;price.className='nlt-favorite-price';info.insertBefore(price,actions);}
  });
 });
 content.append(ul);return;
}
const table=element('table'),head=element('thead'),tr=element('tr');tr.append(element('th',''));items.forEach(p=>{const th=element('th');th.scope='col';th.append(link(p));tr.append(th);});head.append(tr);table.append(head);const body=element('tbody');for(const field of ['price','brand','type','stock']){const row=element('tr'),th=element('th',l[field]);th.scope='row';row.append(th);items.forEach(p=>row.append(element('td',p[field]||l.unknown)));body.append(row);}const row=element('tr');row.append(element('th',''));items.forEach(p=>{const td=element('td');td.append(remove(p));row.append(td);});body.append(row);table.append(body);content.append(table);}
});
customElements.define('nlt-shop-card',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',e=>{const b=e.target.closest('[data-action]');if(!b)return;const key=b.dataset.action,index=saved[key].findIndex(p=>p.id===this.dataset.id),tools=document.querySelector('nlt-shop-tools');if(key==='favorite'){tools?.changeFavorite({...this.dataset},index>=0);return;}if(index>=0)saved[key].splice(index,1);else{if(key==='compare'&&saved[key].length>=3){if(tools)tools.querySelector('[role=status]').textContent=tools.labels.limit;return;}saved[key].push({...this.dataset});}if(tools)tools.querySelector('[role=status]').textContent='';sync();});sync();}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-truck-offer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-truck-offer')){
customElements.define('nlt-truck-offer',class extends HTMLElement{
connectedCallback(){
const initialize=()=>{
if(this.dataset.ready)return;
const form=this.querySelector('form');
if(!form)return;
this.dataset.ready='true';
const name=form.querySelector('[data-offer-name]'),amount=form.querySelector('[data-offer-amount]'),message=form.querySelector('[data-offer-message]'),button=form.querySelector('button');
const update=()=>{
const value=Number(amount.value);
const money=Number.isFinite(value)&&value>0?new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(value)+' MXN':amount.value;
message.value=[this.dataset.intro,'Stock: '+this.dataset.stock,name.dataset.label+': '+name.value.trim(),amount.dataset.label+': '+money,this.dataset.details||this.dataset.url].join('\n');
};
form.addEventListener('input',update);
form.addEventListener('change',update);
form.addEventListener('submit',update);
button.addEventListener('click',update);
update();button.disabled=false;
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
}
});
}
  } catch(e) { console.error(e); }
})();

})();
